// Setup jquery
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');

// Npm
require('bootstrap');
require('lazysizes/plugins/respimg/ls.respimg.min');
require('lazysizes/plugins/bgset/ls.bgset.min');
require('lazysizes');
require('slick-carousel');
require('@fancyapps/fancybox');

// Js files
require('./lazysizes-conf');
require('./custom');
